import { DOCUMENT_MAIN_TYPE, MODEL_TYPE } from '../constants/index.jsx'

export const JOURNAL_HELPER = {
  DOCUMENT: {
    journalEntryHeaderApplyConfig: (config, entityModelId) => {
      config.params.filter.push(['account_id', '=', entityModelId])
    },
    journalEntryHeaderApplyData: (data, model) => {
      const isCredit = [
        MODEL_TYPE.PURCHASE_INVOICE,
        MODEL_TYPE.SALES_ADVANCE_INVOICE,
        MODEL_TYPE.SALES_CREDIT_MEMO,
        MODEL_TYPE.PURCHASE_FINANCE_CHARGE
      ].includes(model.type)

      const amount = model.main_type === DOCUMENT_MAIN_TYPE.PURCHASE
        ? model.external_document_amount
        : model.total
      const amountLcy = amount * model.currency_rate

      data.currency_id = model.currency_id
      data.currency = model.currency
      data.currency_rate = model.currency_rate

      data.debit = isCredit ? 0 : amount
      data.credit = isCredit ? amount : 0
      data.debit_lcy = isCredit ? 0 : amountLcy
      data.credit_lcy = isCredit ? amountLcy : 0

      data.entry_no = model.no
      data.entry_date = model.date
      data.entry_due_date = model.due_date
      data.ext_entry_no = model.external_document_number
      data.ext_entry_date = model.external_document_date

      data.amount = model.total

      data.location_id = model.location_id
      data.location = model.location
      data.responsibility_center_id = model.responsibility_center_id
      data.responsibility_center = model.responsibility_center

      data.bank_account_id = model.bank_account_id
      data.bank_account = model.bank_account
    },
    journalEntryLineApplyConfig: (config, entryHeaderModelId) => {
      //
    },
    journalEntryLineApplyData: (data, model) => {
      //
    }
  },
  BANK_STATEMENT: {
    journalEntryHeaderApplyConfig: (config, entityModelId) => {
      config.params.filter.push(['bank_account_id', '=', entityModelId])
    },
    journalEntryHeaderApplyData: (data, model) => {
      data.currency_id = model.currency_id
      data.currency = model.currency
      data.currency_rate = model.currency_rate

      // TODO: credit/debit values
      // data.debit = 0
      // data.credit = 0
      // data.debit_lcy = 0
      // data.credit_lcy = 0

      data.entry_no = model.no
      data.entry_date = model.date

      data.amount = model.total

      data.bank_account_id = model.bank_account_id
      data.bank_account = model.bank_account
    },
    journalEntryLineApplyConfig: (config, entryHeaderModelId) => {
      //
    },
    journalEntryLineApplyData: (data, model) => {
      //
    }
  },
  CASHIER: {
    journalEntryHeaderApplyConfig: (config, entityModelId) => {
      config.params.filter.push(['cash_account_id', '=', entityModelId])
    },
    journalEntryHeaderApplyData: (data, model) => {
      const isCredit = [
        MODEL_TYPE.CASHIER_RECEIVES
      ].includes(model.type)

      /**
       * TODO: Update logic for amount when CASHIER_PAYS
       */
      const amount = model.type === MODEL_TYPE.CASHIER_RECEIVES
        ? model.total
        : model.total
      const amountLcy = amount * model.currency_rate

      data.currency_id = model.currency_id
      data.currency = model.currency
      data.currency_rate = model.currency_rate

      data.debit = isCredit ? 0 : amount
      data.credit = isCredit ? amount : 0
      data.debit_lcy = isCredit ? 0 : amountLcy
      data.credit_lcy = isCredit ? amountLcy : 0

      data.entry_no = model.no
      data.entry_date = model.date

      data.amount = amount
    },
    journalEntryLineApplyConfig: (config, entryHeaderModelId) => {
      //
    },
    journalEntryLineApplyData: (data, model) => {
      //
    }
  },
  PHYSICAL_INVENTORY: {
    journalEntryHeaderApplyConfig: (config, entityModelId) => {
      //
    },
    journalEntryHeaderApplyData: (data, model) => {
      data.location_id = model.location_id
      data.location = model.location
      data.responsibility_center_id = model.responsibility_center_id
      data.responsibility_center = model.responsibility_center

      // TODO: PHYSICAL_INVENTORY credit/debit values
      // data.debit = 0
      // data.credit = 0
      // data.debit_lcy = 0
      // data.credit_lcy = 0

      data.entry_no = model.no
      data.entry_date = model.date

      data.amount = model.total
    },
    journalEntryLineApplyConfig: (config, entryHeaderModelId) => {
      //
    },
    journalEntryLineApplyData: (data, model) => {
      //
    }
  }
}
